import { Alert, Switch } from "@xola/ui-kit";
import React, { useEffect, useState } from "react";
import { RichEditor } from "../../Common/RichEditor";

interface EmailFooterProps {
    value: string;
    handleEmailFooterChange: (html: string | null) => any;
}

export const EmailFooter = ({ value, handleEmailFooterChange }: EmailFooterProps) => {
    const [shouldOverrideGlobalFooter, setShouldOverrideGlobalFooter] = useState(!!value);

    useEffect(() => {
        setShouldOverrideGlobalFooter(!!value);
    }, [value]);

    const toggleOverrideSwitch = () => {
        setShouldOverrideGlobalFooter(!shouldOverrideGlobalFooter);
        handleEmailFooterChange("");
    };

    return (
        <>
            <div className="mb-3">
                <Alert color="primary">
                    {shouldOverrideGlobalFooter ? (
                        <div>
                            <span className="text-base">
                                This experience is not using the global custom email footer. It is using the settings
                                configured below.
                            </span>
                            <div className="my-2 mb-2 flex items-center space-x-2">
                                <Switch
                                    size="medium"
                                    isChecked={shouldOverrideGlobalFooter}
                                    onChange={toggleOverrideSwitch}
                                />
                                <h5 className="font-bold">Override global email footer</h5>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <span className="text-base">
                                This experience is using the global custom email footer. You can configure custom footer
                                specific to this product by overriding the global settings below.
                            </span>
                            <div className="my-2 mb-2 flex items-center space-x-2">
                                <Switch
                                    size="medium"
                                    isChecked={shouldOverrideGlobalFooter}
                                    onChange={toggleOverrideSwitch}
                                />
                                <h5 className="font-bold">Override global email footer</h5>
                            </div>
                        </div>
                    )}
                </Alert>
            </div>

            {shouldOverrideGlobalFooter && (
                <RichEditor
                    initialContent={value ?? ""}
                    showVariableButton={false}
                    onChange={handleEmailFooterChange}
                />
            )}
        </>
    );
};
